import styled from 'styled-components';
import { Divider as MuiDivider } from '@material-ui/core';

export const Divider = styled(MuiDivider)`
  margin-bottom: 32px;
`;

export const SidebarContainer = styled.div`
  border-right: 1px solid var(--grayLv4);
  width: 214px;
  padding: 24px 16px;
  background: var(--backgroundSidebar);
  height: calc(100vh - 64px);
  margin-top: 64px;

  @media(min-width:960px) {
    overflow-y: auto;
    margin-top: 0;
    height: 100vh;
  }
`;

export const SidebarWrap = styled.div`
	width: 100%;
`;

export const LogoWrap = styled.div`
  /* margin-bottom: 32px; */
  margin: 8px 0 32px 0;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
  }

  @media(min-width: 1920px) {
    /* height: 144px; */
    /* padding: 40px; */
    /* img {
      height: 100%;
    } */
  }
`;